import React from 'react';
import Button from '@mui/material/Button';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useDeletePermitted } from './DeleteIconButton';

// CP-5545: a delete with a text label — always outlined red with the trash icon, never filled. Keep any count
// in the label ("Delete (2)"). `perm` / `allowed` work as on DeleteIconButton: no permission = disabled, not hidden.
/** @type {React.ForwardRefExoticComponent<Record<string, any> & React.RefAttributes<HTMLButtonElement>>} */
const DeleteButton = React.forwardRef(function DeleteButton({ perm, allowed = true, disabled = false, children = 'Delete', ...rest }, ref) {
    const permitted = useDeletePermitted(perm, allowed);
    return (
        <Button ref={ref} {...rest} variant="outlined" color="error" startIcon={<DeleteOutlinedIcon />} disabled={disabled || !permitted}>
            {children}
        </Button>
    );
});

export default DeleteButton;
